import React, { useState } from 'react';
const faqs = [{
  q: '¿Necesito experiencia editando videos?',
  a: 'No. La guía empieza desde cero. Si sabes usar Instagram, puedes hacer esto. Las plantillas de CapCut hacen el 80% del trabajo por ti.'
}, {
  q: '¿Qué app uso para editar?',
  a: 'CapCut, que es 100% gratuita y ya está disponible en tu teléfono. También funciona con InShot o la app nativa de tu iPhone. No necesitas nada de pago.'
}, {
  q: '¿Cuánto tiempo necesito al día?',
  a: 'Con 2 horas al día es suficiente para empezar. Muchas mamás trabajan durante la siesta o después de que los niños duermen. Tú decides tu horario.'
}, {
  q: '¿Cómo consigo mis primeros clientes?',
  a: 'La guía incluye scripts exactos de DM para contactar negocios locales en Instagram. Spas, salones, restaurantes y agentes de Real Estate son los mejores nichos para empezar.'
}, {
  q: '¿Funciona si no hablo inglés perfectamente?',
  a: '¡Sí! El mercado hispano en USA es enorme. Puedes trabajar con negocios latinos que prefieren comunicarse en español. Es una ventaja, no un obstáculo.'
}, {
  q: '¿Cuándo recibo acceso a la guía?',
  a: 'Inmediatamente después del pago. Recibes un email con el link de descarga en menos de 5 minutos.'
}, {
  q: '¿Necesito una computadora o laptop?',
  a: 'No. Todo el sistema está diseñado para funcionar desde tu celular. Tu iPhone o Android es tu nueva oficina de edición.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border border-[#0d4a45]/15 rounded-xl overflow-hidden" data-id="element-152">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left bg-white hover:bg-[#fdf6ee] transition-colors" data-id="element-153">
        <span className="font-dm font-semibold text-[#0d4a45] text-base" data-id="element-154">
          {q}
        </span>
        <span className={`text-[#c9a84c] text-xl font-bold shrink-0 transition-transform duration-200 ${open ? 'rotate-45' : ''}`} data-id="element-155">
          +
        </span>
      </button>
      {open && <div className="px-5 pb-4 bg-[#fdf6ee] border-t border-[#0d4a45]/10" data-id="element-156">
          <p className="font-dm text-[#3a3a3a] text-sm leading-relaxed pt-3" data-id="element-157">
            {a}
          </p>
        </div>}
    </div>;
}
export function FAQ() {
  return <section className="bg-[#fdf6ee] py-16 md:py-24" data-id="element-158">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-159">
        <div className="text-center mb-10" data-id="element-160">
          <span className="font-dm text-xs font-bold tracking-widest text-[#c9a84c] uppercase" data-id="element-161">
            Resolvemos tus dudas
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#0d4a45] mt-3" data-id="element-162">
            Preguntas Frecuentes
          </h2>
        </div>
        <div className="space-y-3" data-id="element-163">
          {faqs.map(faq => <FAQItem key={faq.q} q={faq.q} a={faq.a} data-id="element-164" />)}
        </div>
      </div>
    </section>;
}